const myJourney = [
  {
    index: "1",
    Title: "🎓 School Completed",
    Description: "Successfully completed schooling from National High School, Ankleshwar, Gujarat.",
    Date: "March-2022",
  },
  {
    index: "2",
    Title: "☕ Learned Java",
    Description: "Began learning Java through CodeWithHarry’s YouTube course and completed it before starting college.",
    Date: "June-2022",
  },
  {
    index: "3",
    Title: "🏫 College Started",
    Description: "Enrolled in B.Sc. Computer Science at Narmada College of Science & Commerce.",
    Date: "September-2022",
  },
  {
    index: "4",
    Title: "⚛️ Started Learning React.js",
    Description: "Started learning React.js alongside the college curriculum. Although the course was nearly completed, limited practice was possible due to academic workload.",
    Date: "March-2023",
  },
  {
    index: "5",
    Title: "🏆 Secured 1st Position",
    Description: "Achieved 1st position in the department with 8.5 SGPA during the 4th semester.",
    Date: "April-2024",
  },
  {
    index: "6",
    Title: "🚀 Started SalesSahayak Project",
    Description: "Initiated a minor project named SalesSahayak using ASP.NET during the 5th semester.",
    Date: "June-2024",
  },
  {
    index: "7",
    Title: "✅ Completed SalesSahayak Project",
    Description: "Successfully completed the SalesSahayak project and received the highest project marks in the department.",
    Date: "October-2024",
  },
  {
    index: "8",
    Title: "🎮 Started GameVerse Project",
    Description: "Commenced work on GameVerse, a major project built using Pygame and Tkinter in the 6th semester.",
    Date: "December-2024",
  },
   {
    index: "9",
    Title: "🥈 Secured Silver Medals in 1st & 2nd Year",
    Description: "Awarded silver medals for securing 2nd rank in the department for both the first and second year of college.",
    Date: "January-2025",
  },
  {
    index: "10",
    Title: "📦 Completed GameVerse Project",
    Description: "Completed the GameVerse project as part of the final semester major project.",
    Date: "March-2025",
  },
 
  {
    index: "11",
    Title: "🎓 College Graduation",
    Description: "Graduated with a B.Sc. in Computer Science from Narmada College of Science & Commerce, with a CGPA of 7.80.",
    Date: "April-2025",
  },
  {
    index: "12",
    Title: "🌐 Portfolio Website Hosted",
    Description: "Designed my personal portfolio website using React.js and hosted it on Vercel at satyamjha.live",
    Date: "April-2025",
  },
{
  index: "13",
  Title: "📱 Started JointerX Project",
  Description: "Began development of JointerX, a full-fledged personal Android app project designed to connect job seekers with employers, allowing candidates to apply for jobs, and employers to post listings, shortlist, interview, and hire talent seamlessly.",
  Date: "April-2025",
}
,
  {
    index: "14",
    Title: "📖 Kindle Book Published",
    Description: "Wrote a fictional short story book, The Dreamy Train Journey, in May 2025 and published it on Amazon Kindle in June 2025..",
    Date: "June-2025",
    Link:"https://amzn.in/d/9wla08U",
    ButtonText:"View Book",
    isButton:true,
  },
  {
    index: "15",
    Title: "🚀 JointerX Launched on Play Store",
    Description: "Successfully completed and published the JointerX app on the Google Play Store.",
    Date: "July-2025",
    isImage:true,
  },
  {
    index: "16",
    Title: "🌐 JointerX Website Launched",
    Description: "JointerX’s official brand website is now live, providing a complete overview of our platform, services, and mission for job seekers and employers.",
    Date: "August-2025",  
    Link:"https://jointerx.com/",
    ButtonText:"Visit Website",
    isButton:true,
  },
{
  index: "17",
  Title: "🎯 Crossed 100+ Downloads!",
  Description: "Reached an exciting milestone as JointerX surpassed 100 downloads on Google Play. Each install marks growing trust in the platform and validates the effort put into building a smooth experience for both candidates and employers.",
  Date: "September-2025",
  
},
{
  index: "18",
  Title: "🚀 Crossed 500+ Downloads!",
  Description: "JointerX has officially crossed 500 downloads on Google Play! This milestone reflects steady growth, stronger reach, and the increasing trust users are placing in the platform. Every new install motivates continuous improvement and pushes the vision of JointerX forward.",
  Date: "November-2025",
},
{
  index: "19",
  Title: "🚀 1K+ Downloads & 500+ Registered Users — A Milestone for JointerX",
  Description: "JointerX has crossed 1K+ downloads on Google Play along with 500+ registered users 🎉.This milestone reflects the trust of early users, steady progress, and a growing community of candidates and employers. Every download reinforces our vision of building a meaningful, reliable hiring platform—and this is just the beginning.",
  Date: "January-2026",
}

];

export default myJourney;
